module.exports = __webpack_public_path__ + "media/notification.4fc4be4d.mp3";